module.exports = __webpack_public_path__ + "img/img_innovation1.f401fe7d.png";